import { render } from "./TicketReceivedView.vue?vue&type=template&id=04acde05&scoped=true"
import script from "./TicketReceivedView.vue?vue&type=script&lang=js"
export * from "./TicketReceivedView.vue?vue&type=script&lang=js"

import "./TicketReceivedView.vue?vue&type=style&index=0&id=04acde05&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04acde05"]])

export default __exports__